module.exports = __webpack_public_path__ + "static/img/n_3.1979df07.png";